export default {"src":"/_next/static/media/favicon.487a6a47.ico","height":64,"width":64};